import { useEffect, useState } from 'react';
import store from './redux/store';
import Index from './components/Index';
import { Provider } from "react-redux";
import ScrollToTopButton from './components/ScrollToTopButton';
import TopHeader from "./components/TopHeader";
import BaseHeader from "./components/BaseHeader";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import UpdateUser from './components/auth/UpdateUser';
import Verify from './components/auth/Verify';
import FoodDetail from './pages/foods/FoodDetail';
import Footer from './components/Footer';
import RoomDetail from './pages/rooms/RoomDetail';
import Cart from './pages/userPnael/Cart';
import Dashboard from './pages/userPnael/Dashboard';
import CurrentUser from './CurrentUser';
import RoomsList from './pages/rooms/RoomsList';
import FoodsList from './pages/foods/FoodsList';
import Favorites from './pages/userPnael/Favorites';
import { useGetRoomQuery } from './redux/services/rooms/roomAPI';
import ScrollToTop from './components/ScrollToTop';
import Checkout from './pages/userPnael/Checkout';
import ChangePassword from './components/auth/ChangePassword';
import Advertising from './components/Advertising';
import Contact from './pages/hotel/Contact';
import Articles from './pages/blog/Articles';
import CheckMobile from './components/auth/CheckMobile';
import './components/sweetalert2-custom.css';

function App() {
  const [user, setUser] = useState(null);
  const { data: rooms, isError, error, isLoading } = useGetRoomQuery();

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    } catch {
      setUser(null);
    }
  }, []);

  const handleUserChange = (userData) => {
    setUser(userData);
  };

  const EnhancedCart = CurrentUser(Cart);
  const EnhancedFoodsList = CurrentUser(FoodsList);
  const EnhancedRoomDetail = CurrentUser(RoomDetail);
  const EnhancedRoomsList = CurrentUser(RoomsList);
  const EnhancedUpdateUser = CurrentUser(UpdateUser, handleUserChange);
  const EnhancedIndex = CurrentUser(Index, handleUserChange);
  const EnhancedLogin = CurrentUser(Login);
  const EnhancedFavorites = CurrentUser(Favorites);
  const EnhancedCheckout = CurrentUser(Checkout);
  const EnhancedDashboard = CurrentUser(Dashboard);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <TopHeader user={user} handleUserChange={handleUserChange} />
        <div className="h-14" />
        <BaseHeader />
        <Advertising />

        <main>
          <Routes>
            <Route path="/login" element={<EnhancedLogin handleUserChange={handleUserChange} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/forget-password" element={<CheckMobile />} />
            <Route path="/change-password/:userId" element={<ChangePassword />} />
            <Route path='/cart' element={<EnhancedCart />} />
            <Route path='/update_user/:userId' element={<EnhancedUpdateUser handleUserChange={handleUserChange} />} />
            <Route path='/favorites' element={<EnhancedFavorites />} />
            <Route path='/checkout' element={<EnhancedCheckout />} />
            <Route path='/dashboard' element={<EnhancedDashboard />} />
            <Route path="/" element={<EnhancedIndex data={rooms} isError={isError} error={error} isLoading={isLoading} />} />
            <Route path="/foods" element={<EnhancedFoodsList />} />
            <Route path="/food/:foodName" element={<FoodDetail />} />
            <Route path="/rooms" element={<EnhancedRoomsList data={rooms} isError={isError} error={error} isLoading={isLoading} />} />
            <Route path="/room/:roomName" element={<EnhancedRoomDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Articles />} />
          </Routes>
        </main>

        <ScrollToTopButton />
        <Footer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
